module.exports = __webpack_public_path__ + "static/media/img1-1.e5a3d55d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/chile/biosense/diff/img1-1.png
// module id = 1426
// module chunks = 3